const baseAccountUrl = "Account"
const baseGeneralUrl = "General"
const baseUserlUrl = "User"
const baseContractUrl = "Contract"
const baseEIDSUrl = "eids"

  const endpoints = {
   getToken:`${baseAccountUrl}/Login`,
   registerUser:`${baseAccountUrl}/Register`,
   userInfo:`${baseAccountUrl}/UserInfo`,
   getSMSCode:`${baseGeneralUrl}/GetSmsVerifyCode/`,
   activateVerification:`${baseUserlUrl}/ActivateVerification`,
   getVerificationInfo:`${baseUserlUrl}/getVerificationInfo`,
   getExternalLogin:`${baseAccountUrl}/ExternalLogin`,
   forgotPassord:`${baseAccountUrl}/ForgotPassword`,
   setPassord:`${baseAccountUrl}/SetPassword`,
  //  getUserInfoByPhoneNumber:`${baseUserlUrl}/GetUserInfoByPhoneNumber/`,
   getUserInfoByPhoneNumber:`${baseUserlUrl}/GetUserInfoMaskedByPhoneNumber/`,
   getIndividualContract:`${baseContractUrl}/GetIndividual`,
   eids:`${baseEIDSUrl}`,
   getUserCode:`${baseGeneralUrl}/EidsGetUserCode`,
 
   
  };
  
  export default endpoints;
  